import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: '91破解版是什么？',
    a: '91破解版是指对原版付费应用进行逆向工程、去除授权验证机制后重新打包分发的版本，声称可"免费使用全部功能"。实际上，这些版本来源不明，代码被非法修改，存在严重的安全隐患和法律风险。',
  },
  {
    q: '91破解版安全吗？',
    a: '不安全。根据多家安全研究机构报告，超过60%的破解版应用包含恶意代码。这些代码可能窃取您的隐私数据、监控您的操作行为、在后台下载其他恶意软件，甚至将您的设备变成网络攻击的工具。我们强烈建议不要下载和使用任何来源的破解版应用。',
  },
  {
    q: '91破解版下载后如何安装？',
    a: '破解版通常需要开启"允许安装未知来源应用"权限才能安装。安装前请仔细审查应用申请的权限列表。需要提醒的是，安装破解版意味着您主动绕过了系统的重要安全防线，这将使您的设备面临极大的安全风险。我们建议您优先考虑正版或免费替代方案。',
  },
  {
    q: '有没有安全的91破解版替代方案？',
    a: '有的！市面上有大量优秀的正版免费或低价应用可以替代破解版。例如WPS Office（办公）、Canva（设计）、VLC（影音播放）、剪映（视频编辑）、GIMP（图像处理）等。这些应用来自可信的开发者，安全可靠且持续获得更新。',
  },
  {
    q: '使用91破解版会被追究法律责任吗？',
    a: '虽然日常生活中个体用户被追究的案例较少，但根据《中华人民共和国著作权法》和《计算机软件保护条例》，使用和传播破解版软件属于侵犯知识产权的违法行为。对于企业用户来说，使用盗版软件面临的法律和经济风险更为严重。',
  },
  {
    q: '如何正确获取和使用正版应用？',
    a: '您可以通过官方应用商店（如App Store、华为应用市场、小米应用商店等）下载正版应用。如果觉得价格较高，可以关注应用的限时优惠活动，或选择功能充足的免费版本。许多应用还提供学生优惠和家庭共享方案。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />
      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              关于91破解版的常见问题
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              您可能关心的91破解版相关问题，这里都有答案
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                  onClick={() => toggleFaq(index)}
                >
                  <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                    {faq.q}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <p className="text-sm text-foreground-500 mb-4">
              没有找到您想要的答案？
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-white border border-background-300 text-foreground-700 hover:text-foreground-950 hover:border-foreground-300 px-6 py-2.5 rounded-lg font-medium text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line"></i>
              联系我们
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}